<template>
  <div class="anslysis-box">
    <p class="label error error-color" v-if="myAnswer.isCorrect === 0">
      <img class="icon" src="../../assets/images/icons/icon-analysis-error.png" alt="">
      <span>回答错误</span>
    </p>
    <p v-else class="label right right-color">
      <img class="icon" src="../../assets/images/icons/icon-analysis-right.png" alt="">
      <span>回答正确</span>
    </p>
    <div class="result-area">
      <div class="result-area-l">
        <p class="correct-answer answer">
          <i class="icon-right"></i>
          <span>正确答案：</span>
          <span class="right-color">{{correctAnswer}}</span>
        </p>
        <p class="answer">
          <i :class="[myAnswer.isCorrect === 0 ? 'icon-error' : 'icon-right']"></i>
          <span>我的答案：</span>
          <span :class="[myAnswer.isCorrect === 0 ? 'error-color' : 'right-color']">{{myAnswer.answer}}</span>
        </p>
      </div>
      <div class="result-area-r">
        <!-- <p class="close-analysis">收起解析</p> -->
      </div>
    </div>
    <div class="analysis-area">
      <p class="title-text">答案解析</p>
      <div v-html="analysis"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    analysis: {
      type: String,
      default: ''
    },
    correctAnswer: {
      type: String,
      default: ''
    },
    myAnswer: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      
    }
  },
  computed: {

  },
  watch: {

  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
  @import '../../assets/css/style.scss';
  .error-color {
    color: #F94D48;
  }
  .right-color {
    color: #23C086;
  }
  .icon {
    width: 14px;
    vertical-align: middle;
  }
  .anslysis-box {
    .label {
      width: 120px;
      height: 32px;
      line-height: 32px;
      border-radius: 6px 6px 0px 0px;
      text-align: center;
      margin-left: 50px;
      &.error {
        background: #FFEDED;
      }
      &.right {
        background: #E3FBF2;
      }
      span {
        vertical-align: middle;
      }
    }
  }
  .result-area {
    width: 100%;
    background-color: #F9F9F9;
    color: #666666;
    border-top: 1px dotted #E6E6E6;
    @include flex-between-and-vertical-center();
    padding: 0 30px 0 50px;
    .result-area-l {
      height: 48px;
      @include flex-vertical-center();
    }
    .answer {
      i {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 100px;
        margin-right: 10px;
        &.icon-right {
          background-color: #23C086;
        }
        &.icon-error {
          background-color: #F94D48FF;
        }
      }
    }
    .correct-answer {
      margin-right: 50px;
    }
    .close-analysis {
      font-size: 14px;
      cursor: pointer;
    }
  }
  .analysis-area {
    padding: 20px 50px;
    .title-text {
      font-weight: 500;
      line-height: 22px;
      @include flex-vertical-center();
      margin-bottom: 20px;
      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 20px;
        background-color: $color-primary;
        margin-right: 8px;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/questions/analysis.vue